import React from 'react';

import * as S from './styles';

function Scissor() {
  return <S.Tiscissor />;
}

export default Scissor;